import { createElementBlock as o, openBlock as s, createElementVNode as t } from "vue";
const r = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-laptop"
};
function n(l, e) {
  return s(), o("svg", r, e[0] || (e[0] = [
    t("path", {
      d: "M6.57851 18.3909L5.07776 23.6966C4.71172 24.9907 5.68395 26.2761 7.02882 26.2761H23.9712C25.3161 26.2761 26.2883 24.9907 25.9222 23.6966L24.4215 18.3909M6.57851 18.3909V8.02761C6.57851 6.90779 7.4863 6 8.60612 6H22.3939C23.5137 6 24.4215 6.90779 24.4215 8.02761V18.3909H6.57851ZM6.57851 18.3909H24.4215H6.57851Z",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    t("path", {
      d: "M13 23H19",
      stroke: "#0AA5FF",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--default-cyan-03"
    }, null, -1),
    t("path", {
      d: "M14 21H18",
      stroke: "#0AA5FF",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--default-cyan-03"
    }, null, -1),
    t("path", {
      d: "M13.5737 9.58685L15.7299 8.67823L17.8862 9.58685L18.7851 11.7946L17.8862 14.0024L15.7299 14.911L13.5737 14.0024L12.6748 11.7946L13.5737 9.58685Z",
      stroke: "#0AA5FF",
      "stroke-width": "1.25",
      class: "svg__stroke--default-cyan-03"
    }, null, -1)
  ]));
}
const d = { render: n };
export {
  d as default,
  n as render
};
